import { MessagePipe } from './message-pipe';
import { RuntimeFrameworkService } from '../rtf-service';
import { Subject } from 'rxjs';
import { QuerystringService } from '../querystring';

export class MessagePipeService {
  private static rtfService: RuntimeFrameworkService = new RuntimeFrameworkService();
  private static querystringService: QuerystringService = new QuerystringService();
  /**
   * éè¿tokenè·åæ¶æ¯ç®¡é
   * @param token æ¶æ¯ç®¡éæ è¯
   */
  public static get(token: string): MessagePipe {
    const pipe = new MessagePipe(token, this.rtfService);
    return pipe;
  }
  /**
   * åå»ºæ¶æ¯ç®¡é
   * @param pipeName ç®¡éåç§°
   * @param useFormContext æ¯å¦ä½¿ç¨è¡¨åä¸ä¸æåå»ºç®¡éæ è¯
   * @param pipeType ç®¡éç±»å(å¯é)ï¼é»è®¤Subject<any>
   */
  public static create(pipeName: string, useFormContext: boolean, pipeType?: Subject<any>): MessagePipe {
    let options = null;
    if (useFormContext) {
      const params = this.querystringService.parse(window.location.hash);
      const { funcId, appId, appEntrance } = params;
      options = { funcId, appId, appEntrance };
    }
    const token = this.rtfService.subjectRegister(pipeName, options, pipeType);
    if (!token) {
      return null;
    }
    const pipe = new MessagePipe(token, this.rtfService);
    return pipe;
  }
}
